<template>
  <div>
    <SpFinder
      ref="finder"
      row-key="default_item_id"
      :split-count="10"
      :url="table_url"
      :setting="setting"
      fixed-row-action
      reserve-selection
      :hooks="{
        beforeSearch: beforeSearch,
      }"
    />
  </div>
</template>
<script>
import { createSetting } from '@shopex/finder'
import { List, savePrice } from './api'

export default {
  components: {
  },
  computed: {
  },
  data () {
    return {
      setting: createSetting({
        search: [
          {
            name: '商品名称',
            key: 'item_name',
          }
        ],
        columns: [
          {
            name: '商品',
            key: 'default_item_id'
          },
          {
            name: '商品名称',
            key: 'item_name'
          },
          {
            name: '订单金额（元）',
            key: '',
            render: (h, { row }) => {
              return <el-input v-model={row.price} placeholder='金额' on-change={(value) => this.inputChange(row, value)} />
            }
          }
        ]
      }),
      table_url: List,
      tagsList: [],
    }
  },
  mounted() {
  },
  methods: {
    beforeSearch(params) {
      params = {
        ...params,
        page_size: params.pageSize,
        ...this.formData
      }
      return params
    },
    inputChange (row, value) {
      console.log(row, value)
      savePrice({ price: value, default_item_id: row.default_item_id }).then(res => {
        this.$message.success('修改成功!')
        this.$refs.finder.refresh()
      }).catch(err => {
        this.$message.error('修改失败!')
        this.$refs.finder.refresh()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.nationalmanage-header {
  display: flex;
  justify-content: space-between;
  align-items: center
}
</style>
<style lang="scss">

</style>

